import { useSuspenseQuery } from '@tanstack/react-query';

import { giftQueryFactory } from '@/shared/factories/giftQueryFactory';

export const useGiftDetail = (giftNo: number) => useSuspenseQuery(giftQueryFactory.detail(giftNo));
